import {useState} from "react";

import {AntdTable} from "@/components/custom/AntdTable/AntdTable.jsx";
import {PM02Projection} from "@/variants/index.js";

export const PM02ProjectionTab = ({pm02Data}) => {
	const [tableParams, setTableParams] = useState({
		pagination: {
			current: 1,
			pageSize: 50,
		},
	});

	function handleTableChange(pagination, filters, sorter) {
		setTableParams({
			pagination,
			filters,
			...sorter,
		});
	}

	return (
		<AntdTable
			tableSize={"small"}
			scroll={300}
			data={pm02Data}
			pagination={tableParams.pagination}
			onChange={handleTableChange}
			columns={PM02Projection.getColumns(pm02Data)}
		/>
	);
};
